import api from './api';
import type { PreferenceMatchReason } from '../types';

export interface NotificationPreferences {
  saved_deadline_reminders: boolean;
  daily_digest_email: boolean;
  new_match_in_app: boolean;
}

export interface NotificationItem {
  id: number;
  event_type: string;
  title: string;
  body: string;
  action_path: string | null;
  created_at: string;
  read_at: string | null;
  inactive_at: string | null;
  inactive_reason: string | null;
  is_unread: boolean;
  metadata: { deadline_date?: string; due_at?: string | null; organization?: string; match_reasons?: PreferenceMatchReason[] };
}

export const notificationAPI = {
  list: (cursor?: string) => api.get<{
    notifications: NotificationItem[]; next_cursor: string | null; unread_count: number;
  }>('/api/notifications', { params: cursor ? { cursor } : {} }),
  count: () => api.get<{ unread_count: number }>('/api/notifications/unread-count'),
  read: (id: number) => api.post(`/api/notifications/${id}/read`),
  unread: (id: number) => api.post(`/api/notifications/${id}/unread`),
  readAll: () => api.post('/api/notifications/read-all'),
  preferences: () => api.get<{ preferences: NotificationPreferences }>('/api/notifications/preferences'),
  setPreference: (key: keyof NotificationPreferences, enabled: boolean) =>
    api.put<{ preferences: NotificationPreferences }>('/api/notifications/preferences', { [key]: enabled }),
};
